import { render, staticRenderFns } from "./depositList.vue?vue&type=template&id=04fa000f&scoped=true"
import script from "./depositList.vue?vue&type=script&lang=js"
export * from "./depositList.vue?vue&type=script&lang=js"
import style0 from "./depositList.vue?vue&type=style&index=0&id=04fa000f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04fa000f",
  null
  
)

export default component.exports